<template>
  <div style="width: 100%;height:  500px;">
    <div id="baiduMap" style="width: 100%;height: 500px;" />
  </div>
</template>

<script>
  export default {
    props: {
      currentCity:{
        type:String,
        default:'北京市'
      },
      zoom:{
        type:Number,
        default:16
      },
      centerLocation:{
        type:String
      },
      address:{
        type:String
      }
    },
    data() {
      return {
        hasInitMap: false,
        map: null
      }
    },
    watch:{
      currentCity(){
        this.changeAddress()
      },
      address(){
        this.changeAddress()
      },
      centerLocation(){
        this.changeLocation()
      }
    },
    mounted() {
      this.initBaiduMap()
    },
    methods: {
      changeAddress(){
        let that=this
        if (this.address || this.currentCity) {
          let myGeo = new BMap.Geocoder();
          myGeo.getPoint(that.address ? that.address : (that.currentCity?that.currentCity:'北京市'), function(point) {
            if (point) {
              that.map.centerAndZoom(point, that.zoom);
              let marker = new BMap.Marker(point, {
                enableDragging: true
              })
              that.map.addOverlay(marker);
              marker.addEventListener("dragend", function() {
                var curPoint = marker.getPosition();
                that.$emit("changeValue",curPoint.lng+","+curPoint.lat)
              })
            }
          }, that.currentCity?that.currentCity:'北京市');
          // that.map.centerAndZoom(this.centerAddress,this.zoom)
        }
      },
      changeLocation(){
        let that=this
        if (this.centerLocation) {

        let location=this.centerLocation.split(",")
        let point=new BMap.Point(location[0], location[1])
        that.map.centerAndZoom(point, this.zoom) // 创建点坐标,初始化地图,设置中心点坐标和地图级别
          let marker = new BMap.Marker(point, {
            enableDragging: true
          })
          that.map.addOverlay(marker);
          marker.addEventListener("dragend", function() {
            var curPoint = marker.getPosition();
            that.$emit("changeValue",curPoint.lng+","+curPoint.lat)
          })
          }
      },
      setLocation(){
        let that=this
        that.map.setCurrentCity(this.currentCity)
        if (this.centerLocation) {

        } else {
          that.changeAddress()

        }
      },
      initBaiduMap() {
        const _that = this

        // console.error("===========      initBaiduMap() {")
        let that = this
        if (that.map == null) {
          that.map = new BMap.Map('baiduMap') // 创建Map实例
          that.map.addEventListener('zoomend', function(e) {
            var ZoomNum = that.map.getZoom()
          })

          _that.hasInitMap = true
        }

        that.map.enableScrollWheelZoom(); // 允许滚轮缩放
        that.setLocation()
      },
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwMoveMapLocation.vue